import * as React from 'react';
import { Svg } from '../svg';

function SvgSvgWarning3({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10 18.334a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667zM10 6.667V10M10 13.333h.008"
        stroke="#F63"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgSvgWarning3);
export default ForwardRef;
